module.exports = __webpack_public_path__ + "img/white-office-desk-with-hand-touching-mobile-phone@2x.5c227bf2.png";